// `pending.page.tpl.html` — the whole screen, verbatim:
//
//     <div class="chrome-extension-pending-page">
//       Pending page
//     </div>
//
// ⚠️ TWELVE CHARACTERS, AND THE CAPTURE HAD TO LEARN THAT. `waitForStableRender`'s first
// version rejected anything under twenty characters as "the app never painted", which correctly
// refused the WOO splash and then also refused this — the one route whose complete content is
// shorter than the splash's own. The reference exists because that check became an exact match
// on the splash's text instead of a length floor.
//
// The page's stylesheet upstream is `.chrome-extension-pending-page {}` — an empty rule. It is
// ported as nothing rather than as an empty block: there is no declaration to preserve, and the
// class is on the div regardless.
import type { ReactElement } from 'react'
import { PageHost } from '../auth/PageHost.tsx'

export function PendingPage(): ReactElement {
  return (
    <PageHost name="chrome-extension-pending-page">
      Pending page
    </PageHost>
  )
}
